import React, {memo, useContext, useEffect, useState, useRef} from 'react';
import {Route, Redirect, useLocation, useHistory} from 'react-router-dom';

import routes from "../../constants/Routes";
import AppContext from '../../contexts/AppContext';
import GLOBAL from "../../global";
import {isNSCSubdomain} from "../../utils/Utils";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";

const FORBIDDEN_ROUTES_FOR_NSC = [
    routes.myCalendar,
    routes.myExercises,
    routes.myReports,
    routes.myAssessments,
    `${routes.myAssessments}` + '/false',
    `${routes.myAssessments}` + '/true'
];

const PrivateRoute = memo(props => {
    const { authenticated } = useContext(AppContext);
    const { component: Component, ...otherProps } = props;

    const location = useLocation();
    const history = useHistory();
    const { isAthleteEnabled } = useTenantFeatures();

    useEffect(() => {
        if(!GLOBAL.USER_INFO?.CreditCardCount && GLOBAL.IS_SUBSCRIPTION_ENABLED) {
            if(!location.pathname.includes(`${routes.addCard}`)) {
                history.push(routes.addCard);
            }
        }

        // if(isNSCSubdomain() && FORBIDDEN_ROUTES_FOR_NSC.includes(location.pathname)) {
        //     if (isAthleteEnabled) {
        //         history.push(`${routes.myAssessments}/false`, { refresh: true });
        //     } else {
        //         history.push(routes.dashboard);
        //     }
        // }

    }, [location.pathname]);

    return (
        <Route
            render={props =>
                authenticated ? (
                    <>
                        <Component {...props} />
                    </>

                ) : (
                    <Redirect exact to={`${routes.landing}${location?.search}`}/>
                )
            }
            {...otherProps}
        />
    );
});

export default PrivateRoute;
